import { Box } from '@chakra-ui/layout'
import React from 'react'

export const Heading = () => {
  return (
    <Box as="h2" textAlign="center">
      Leave a comment
    </Box>
  )
}
